import React from 'react';

const LiveCasinoV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.66797 6.66845C1.66797 5.2874 2.78753 4.16785 4.16857 4.16785H15.8381C17.2191 4.16785 18.3387 5.2874 18.3387 6.66845V13.3367C18.3387 14.7178 17.2191 15.8373 15.8381 15.8373H4.16857C2.78753 15.8373 1.66797 14.7178 1.66797 13.3367V6.66845Z",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.89042 11.6779C6.89042 11.9033 6.70771 12.086 6.48233 12.086H4.92728C4.46694 12.086 4.09375 11.7129 4.09375 11.2525V8.36215C4.09375 8.11522 4.29393 7.91504 4.54086 7.91504C4.78779 7.91504 4.98797 8.11522 4.98797 8.36215V11.2698H6.48233C6.70771 11.2698 6.89042 11.4526 6.89042 11.6779Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.28173 11.6389C8.28173 11.8859 8.08155 12.086 7.83462 12.086C7.58769 12.086 7.38751 11.8859 7.38751 11.6389V8.36215C7.38751 8.11522 7.58769 7.91504 7.83462 7.91504C8.08155 7.91504 8.28173 8.11522 8.28173 8.36215V11.6389Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.4508 11.541C11.3391 11.867 11.0326 12.086 10.688 12.086C10.3434 12.086 10.0368 11.867 9.92519 11.541L8.88366 8.49955C8.78554 8.21303 8.99848 7.91504 9.30133 7.91504C9.49145 7.91504 9.66022 8.03675 9.72024 8.21714L10.706 11.1798L11.6581 8.22023C11.7166 8.03836 11.8858 7.91504 12.0768 7.91504C12.3786 7.91504 12.5908 8.21197 12.493 8.49747L11.4508 11.541Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.1325 11.699C16.1325 11.9127 15.9592 12.086 15.7454 12.086H13.9353C13.475 12.086 13.1018 11.7129 13.1018 11.2525V8.74857C13.1018 8.28823 13.475 7.91504 13.9353 7.91504H15.7154C15.9292 7.91504 16.1025 8.08835 16.1025 8.30213C16.1025 8.51592 15.9292 8.68923 15.7154 8.68923H13.996V9.59544H15.3313C15.5451 9.59544 15.7184 9.76875 15.7184 9.98254C15.7184 10.1963 15.5451 10.3696 15.3313 10.3696H13.996V11.3119H15.7454C15.9592 11.3119 16.1325 11.4852 16.1325 11.699Z",
      fill: "white"
    }
  )
);

export { LiveCasinoV2 };
//# sourceMappingURL=LiveCasinoV2.js.map
